import React, { useState, useEffect } from "react";
import ReactAudioPlayer from "react-audio-player";
import moment from "moment-timezone";
import { useSelector } from "react-redux";

export default function VoicemailsTable({ voicemails }) {
  const userSelectedFont = useSelector((state) => state.settings.fontsize);
  return (
    <table
      style={{
        fontSize:
          userSelectedFont === "small"
            ? "14px"
            : userSelectedFont === "medium"
            ? "16px"
            : userSelectedFont === "large"
            ? "20px"
            : "20px",
      }}
      className="mt-2 table table-borderless">
      <thead>
        <tr>
          <th className="align-middle" style={{ width: "40%" }} scope="col">
            Recording
          </th>
          <th className="align-middle" style={{ width: "40%" }} scope="col">
            Details
          </th>
          <th className="align-middle" style={{ width: "20%" }} scope="col">
            Date
          </th>
        </tr>
      </thead>

      <tbody>
        {voicemails.chat_data &&
          voicemails.chat_data.map((voicemail) => {
            let local_date = moment
              .utc(voicemail.created_at.replace(/-/g, "/"))
              .local()
              .format("MMM DD, hh:mm A");

            return (
              <tr key={voicemail.id}>
                <td>
                  <ReactAudioPlayer
                    style={{
                      width: "100%",
                    }}
                    src={voicemail.voice_message_file}
                    controls
                  />
                </td>
                {/*<td className="align-middle"><div className="d-flex"><img width="32" height="32" className="img-fluid"
                                            src={playBtnIcon}/><img width="150" src={recordingIcon}/></div></td>*/}
                <td
                  style={{
                    fontSize:
                      userSelectedFont === "small"
                        ? "12px"
                        : userSelectedFont === "medium"
                        ? "14px"
                        : userSelectedFont === "large"
                        ? "18px"
                        : "18px",
                  }}
                  className="align-middle">
                  {voicemail?.message}
                </td>
                <td
                  style={{
                    fontSize:
                      userSelectedFont === "small"
                        ? "12px"
                        : userSelectedFont === "medium"
                        ? "14px"
                        : userSelectedFont === "large"
                        ? "18px"
                        : "18px",
                  }}
                  className="align-middle">
                  {local_date}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
}
